import { Group, Paper, Text } from '@mantine/core';
import { IconCalendarTime } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useMySchedule } from '@/api/schedule';
import { useMembers } from '@/api/workspace';
import { useCurrentWorkspace } from '@/app/WorkspaceContext';
import { PlannedBadge } from '@/features/schedule/PlannedBadge';
import { plannedOn } from '@/features/schedule/plannedDay';
import dayjs from '@/lib/dayjs';

/** Heute geplante Arbeit mit Direktstart des Timers (SCH-06). */
export function PlannedToday() {
  const { t } = useTranslation();
  const ctx = useCurrentWorkspace();
  const today = dayjs().tz(ctx.prefs.timezone).format('YYYY-MM-DD');
  const { data = [] } = useMySchedule(ctx.workspaceId, today, today, ctx.hasFeature('SCHEDULING'));
  const { data: members = [] } = useMembers(ctx.workspaceId);
  const me = members.find((m) => m.userId === ctx.user.id);
  const items = plannedOn(data, today, new Set<string>(me?.workingDays ?? ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY']));
  if (items.length === 0) return null;
  return (
    <Paper withBorder p="xs" mt="xs" radius="md">
      <Group gap="xs" wrap="wrap">
        <Group gap={4}>
          <IconCalendarTime size={16} />
          <Text size="sm" fw={500}>
            {t('schedule.plannedToday')}
          </Text>
        </Group>
        {items.map(({ assignment, hours }) => (
          <div key={assignment.id} style={{ minWidth: 160 }}>
            <PlannedBadge assignment={assignment} hours={hours} />
          </div>
        ))}
      </Group>
    </Paper>
  );
}
